import {css} from '@emotion/core';
import {BRAND_PRIMARY_COLOUR_1} from '~/core/styles/colors';

const globalHeaderStyle = css`
	.icare-header__link--phone {
		align-items: center;
		display: flex;

		svg {
			color: ${BRAND_PRIMARY_COLOUR_1};
			margin-right: 5px;
			width: 19px; // used the zeplin width
		}

		.contact-number {
			color: ${BRAND_PRIMARY_COLOUR_1};
			font-weight: normal;
			font-size: 16px; // used the zeplin font-size
			text-decoration: underline;
		}
	}
`;

export default {
	globalHeaderStyle,
};
